import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import * as Sentry from '@sentry/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSignOut } from '@fortawesome/pro-regular-svg-icons/faSignOut'
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown'
import { faUser } from '@fortawesome/pro-duotone-svg-icons/faUser'

import Dropdown from '@softwaredev_cegeka/stix-core/dist/components/Dropdown'
import AuthApi from '@softwaredev_cegeka/auth-api'

import withUserData from 'src/components/auth/withUserData'
import ImpersonateMenu from 'src/components/Menu/ImpersonateMenu'
import { UserDataContext } from 'src/components/auth/withAuth'
import menuStyles from './menu.module.scss'

const AvatarButton = React.forwardRef((props, ref) => {
    const { userData, defaultOrg, ...rest } = props
    const { impersonatedOrganization, data } = userData
    delete rest.bsPrefix
    delete rest.className
    return (
        <button {...rest} className={menuStyles.userMenuBtn}>
            <span className={menuStyles.iconWrapper}>
                <FontAwesomeIcon
                    icon={faUser}
                    className={menuStyles.userIcon}
                />
            </span>
            <div className={menuStyles.userDataWrapper}>
                <span className={menuStyles.userFirstLastName}>
                    {data?.firstName} {data?.lastName}
                </span>
                <span className={menuStyles.impersonatedTenant}>
                    {impersonatedOrganization?.label || defaultOrg}
                </span>
            </div>
            <FontAwesomeIcon
                className={menuStyles.chevron}
                icon={faChevronDown}
            />
        </button>
    )
})

class UserMenu extends Component {
    static contextType = UserDataContext

    state = { defaultOrg: null, userOrganizations: [] }
    authApi = new AuthApi()

    componentDidMount() {
        this.loadDefaultOrg()
    }

    async loadDefaultOrg() {
        const { data } = this.context
        try {
            const response = await this.authApi.fetchTenants({
                username: data.username,
            })
            const org = response?.data.tenants.find(
                organization =>
                    organization.organization_id === data.organization_id
            )
            this.setState({
                defaultOrg: org.name,
                userOrganizations: response?.data.tenants,
            })
        } catch (e) {
            Sentry.captureException(e)
            console.error(e)
        }
    }

    render() {
        return (
            <Dropdown className={menuStyles.dropdown} align={'right'}>
                <Dropdown.Toggle
                    as={AvatarButton}
                    id="user-dropdown-menu"
                    data-testid={'user-dropdown-menu'}
                    defaultOrg={this.state.defaultOrg}
                    userData={this.props.userData}
                />
                <Dropdown.Menu>
                    <ImpersonateMenu
                        authApiClient={this.authApi}
                        userOrganizations={this.state.userOrganizations}
                        username={this.props.userData?.data?.username}
                    />
                    <NavLink className={menuStyles.logoutLink} to={'/logout'}>
                        <FontAwesomeIcon icon={faSignOut} />
                        <span className={menuStyles.dropdownPanelHeader}>
                            Sign out
                        </span>
                    </NavLink>
                </Dropdown.Menu>
            </Dropdown>
        )
    }
}

export default withUserData(UserMenu)
